var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 793 746"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    strokeWidth: 2,
    d: "M46.553 629V117c0-38.54 31.278-69.818 69.818-69.818h302.545V.636H93.098C41.665.636.008 42.295.008 93.727v558.546c0 51.432 41.657 93.09 93.09 93.09h325.818v-46.545H116.371c-38.586 0-69.818-31.278-69.818-69.818m739.56-272.477L621.53 191.938c-9.077-9.076-23.832-9.076-32.908 0s-9.076 23.831 0 32.908L713.456 349.68H256.007c-12.846 0-23.272 10.426-23.272 23.272 0 12.847 10.426 23.273 23.272 23.273h457.449L588.621 521.061c-9.076 9.076-9.076 23.831 0 32.908 9.076 9.076 23.831 9.076 32.908 0l164.584-164.585c9.077-9.03 9.077-23.738 0-32.861"
  })));
};
export default SvgExit;